/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../connect/v2/common/money';
import './withholding_config';
import '../../../connect/v2/resources/error';
import '../../common/identifier/account_scoped_identifier';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "dashboard": {
            "nested": {
              "withholding_config": {
                "nested": {
                  "CreateWithholdingConfigRequest": {
                    "fields": {
                      "accountId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "targetAmount": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "withholdingConfigs": {
                        "type": "squareup.bbfrontend.dashboard.withholding_config.WithholdingConfig",
                        "id": 3,
                        "rule": "repeated"
                      }
                    }
                  },
                  "CreateWithholdingConfigResponse": {
                    "fields": {
                      "accountWithholdingConfig": {
                        "type": "squareup.bbfrontend.dashboard.withholding_config.AccountWithholdingConfig",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "UpdateWithholdingConfigRequest": {
                    "fields": {
                      "accountId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "targetAmount": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "withholdingConfigs": {
                        "type": "squareup.bbfrontend.dashboard.withholding_config.WithholdingConfig",
                        "id": 3,
                        "rule": "repeated"
                      }
                    }
                  },
                  "UpdateWithholdingConfigResponse": {
                    "fields": {
                      "accountWithholdingConfig": {
                        "type": "squareup.bbfrontend.dashboard.withholding_config.AccountWithholdingConfig",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "AccountIds": {
                    "fields": {
                      "accountIds": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "ListWithholdingConfigsRequest": {
                    "fields": {
                      "owner": {
                        "type": "squareup.bbfrontend.common.account_scoped_identifier.AccountScopedIdentifier",
                        "id": 1,
                        "rule": "optional"
                      },
                      "accountIds": {
                        "type": "squareup.bbfrontend.dashboard.withholding_config.AccountIds",
                        "id": 2
                      }
                    },
                    "nested": {
                      "request_identifier": {
                        "oneof": ["accountIds"]
                      }
                    }
                  },
                  "ListWithholdingConfigsResponse": {
                    "fields": {
                      "accountWithholdingConfigs": {
                        "type": "squareup.bbfrontend.dashboard.withholding_config.AccountWithholdingConfig",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.withholding_config?.nested?.CreateWithholdingConfigRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.withholding_config?.nested?.CreateWithholdingConfigResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.withholding_config?.nested?.UpdateWithholdingConfigRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.withholding_config?.nested?.UpdateWithholdingConfigResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.withholding_config?.nested?.AccountIds && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.withholding_config?.nested?.ListWithholdingConfigsRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.withholding_config?.nested?.ListWithholdingConfigsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreateWithholdingConfigRequest @ squareup/bbfrontend/dashboardweb/withholding_config/withholding_config_request_response.proto at 15:1
 */
export const CreateWithholdingConfigRequest = $root.lookupType('squareup.bbfrontend.dashboard.withholding_config.CreateWithholdingConfigRequest');
fixType(CreateWithholdingConfigRequest, {
  accountId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreateWithholdingConfigRequest);
/**
 * SOURCE CreateWithholdingConfigResponse @ squareup/bbfrontend/dashboardweb/withholding_config/withholding_config_request_response.proto at 21:1
 */
export const CreateWithholdingConfigResponse = $root.lookupType('squareup.bbfrontend.dashboard.withholding_config.CreateWithholdingConfigResponse');
fixType(CreateWithholdingConfigResponse);
Builder.createAndAttachToType(CreateWithholdingConfigResponse);
/**
 * SOURCE UpdateWithholdingConfigRequest @ squareup/bbfrontend/dashboardweb/withholding_config/withholding_config_request_response.proto at 26:1
 */
export const UpdateWithholdingConfigRequest = $root.lookupType('squareup.bbfrontend.dashboard.withholding_config.UpdateWithholdingConfigRequest');
fixType(UpdateWithholdingConfigRequest, {
  accountId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UpdateWithholdingConfigRequest);
/**
 * SOURCE UpdateWithholdingConfigResponse @ squareup/bbfrontend/dashboardweb/withholding_config/withholding_config_request_response.proto at 32:1
 */
export const UpdateWithholdingConfigResponse = $root.lookupType('squareup.bbfrontend.dashboard.withholding_config.UpdateWithholdingConfigResponse');
fixType(UpdateWithholdingConfigResponse);
Builder.createAndAttachToType(UpdateWithholdingConfigResponse);
/**
 * SOURCE AccountIds @ squareup/bbfrontend/dashboardweb/withholding_config/withholding_config_request_response.proto at 38:1
 */
export const AccountIds = $root.lookupType('squareup.bbfrontend.dashboard.withholding_config.AccountIds');
fixType(AccountIds);
Builder.createAndAttachToType(AccountIds);
/**
 * SOURCE ListWithholdingConfigsRequest @ squareup/bbfrontend/dashboardweb/withholding_config/withholding_config_request_response.proto at 42:1
 */
export const ListWithholdingConfigsRequest = $root.lookupType('squareup.bbfrontend.dashboard.withholding_config.ListWithholdingConfigsRequest');
fixType(ListWithholdingConfigsRequest, {
  owner: {
    required: true
  }
});
Builder.createAndAttachToType(ListWithholdingConfigsRequest);
/**
 * SOURCE ListWithholdingConfigsResponse @ squareup/bbfrontend/dashboardweb/withholding_config/withholding_config_request_response.proto at 49:1
 */
export const ListWithholdingConfigsResponse = $root.lookupType('squareup.bbfrontend.dashboard.withholding_config.ListWithholdingConfigsResponse');
fixType(ListWithholdingConfigsResponse);
Builder.createAndAttachToType(ListWithholdingConfigsResponse);